var iconsSvg = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" style=\"display: none;\">\n    <symbol id=\"angle-double-left\" viewBox=\"0 0 448 512\">\n        <title id=\"angle-double-left-title\">Angle Double Left</title>\n        <path d=\"M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z\"></path>\n    </symbol>\n    <symbol id=\"angle-double-right\" viewBox=\"0 0 448 512\">\n        <title id=\"angle-double-right-title\">Angle Double Right</title>\n        <path d=\"M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z\"></path>\n    </symbol>\n    <symbol id=\"angle-left\" viewBox=\"0 0 256 512\">\n        <title id=\"angle-left-title\">angle-left</title>\n        <path d=\"M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z\"></path>\n    </symbol>\n    <symbol id=\"angle-right\" viewBox=\"0 0 256 512\">\n        <title id=\"angle-right-title\">angle-right</title>\n        <path d=\"M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z\"></path>\n    </symbol>\n    <symbol id=\"bars\" viewBox=\"0 0 448 512\">\n        <title id=\"bars-title\">Bars</title>\n        <path d=\"M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z\"></path>\n    </symbol>\n    <symbol id=\"book\" viewBox=\"0 0 448 512\">\n        <title id=\"book-title\">book</title>\n        <path d=\"M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z\"></path>\n    </symbol>\n    <symbol id=\"check\" viewBox=\"0 0 512 512\">\n        <title id=\"check-title\">Check</title>\n        <path d=\"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z\"></path>\n    </symbol>\n    <symbol id=\"check-circle\" viewBox=\"0 0 512 512\">\n        <title id=\"check-circle-title\">Check Circle</title>\n        <path d=\"M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z\"></path>\n    </symbol>\n    <svg id=\"chevron-left\" viewBox=\"0 0 256 512\">\n        <title id=\"chevron-left\">Chevron Left</title>\n        <path d=\"M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z\"></path>\n    </svg>\n    <svg id=\"chevron-right\" viewBox=\"0 0 256 512\">\n        <title id=\"chevron-right\">Chevron Right</title>\n        <path d=\"M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z\"></path>\n    </svg>\n    <symbol id=\"copy\" viewBox=\"0 0 448 512\">\n        <title id=\"copy-title\">Copy</title>\n        <path d=\"M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z\"></path>\n    </symbol>\n    <symbol id=\"exclamation-circle\" viewBox=\"0 0 512 512\">\n        <title id=\"exclamation-circle-title\">Exclamation Circle</title>\n        <path d=\"M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z\"></path>\n    </symbol>\n    <symbol id=\"exclamation-triangle\" viewBox=\"0 0 576 512\">\n        <title id=\"exclamation-triangle-title\">Exclamation Triangle</title>\n        <path d=\"M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z\"></path>\n    </symbol>\n    <symbol id=\"glass-martini\" viewBox=\"0 0 512 512\">\n        <title id=\"glass-martini-title\">Glass Martini</title>\n        <path d=\"M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z\"></path>\n    </symbol>\n    <symbol id=\"handshake\" viewBox=\"0 0 640 512\">\n        <title id=\"handshake-title\">Handshake</title>\n        <path d=\"M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z\"></path>\n    </symbol>\n    <symbol id=\"heart\" viewBox=\"0 0 640 512\">\n        <title id=\"heart-title\">Heart</title>\n        <path d=\"M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z\"></path>\n    </symbol>\n    <symbol id=\"line-lightbulb\" viewBox=\"0 0 352 512\">\n        <title id=\"line-lightbulb-title\">Line Lightbulb</title>\n        <path d=\"M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z\"></path>\n    </symbol>\n    <symbol id=\"line-heart\" viewBox=\"0 0 640 512\">\n        <title id=\"line-heart-title\">Line Heart</title>\n        <path d=\"M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z\"></path>\n    </symbol>\n    <symbol id=\"image\" viewBox=\"0 0 512 512\">\n        <title id=\"image-title\">Image</title>\n        <path d=\"M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z\"></path>\n    </symbol>\n    <symbol id=\"info-circle\" viewBox=\"0 0 512 512\">\n        <title id=\"info-circle-title\">Info Circle</title>\n        <path d=\"M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z\"></path>\n    </symbol>\n    <symbol id=\"key\" viewBox=\"0 0 512 512\">\n        <title id=\"key-title\">key</title>\n        <path d=\"M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z\"></path>\n    </symbol>\n    <symbol id=\"line-check-circle\" viewBox=\"0 0 512 512\">\n        <title id=\"check-circle-title\">Line Check Circle</title>\n        <path d=\"M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z\"></path>\n    </symbol>\n    <symbol id=\"line-exclamation-circle\" viewBox=\"0 0 512 512\">\n        <title id=\"exclamation-circle-title\">Line Exclamation Circle</title>\n        <path d=\"M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z\"></path>\n    </symbol>\n    <symbol id=\"line-exclamation-triangle\" viewBox=\"0 0 512 512\">\n        <title id=\"exclamation-triangle-title\">Line Exclamation Triangle</title>\n        <path d=\"M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z\"></path>\n    </symbol>\n    <symbol id=\"line-info-circle\" viewBox=\"0 0 512 512\">\n        <title id=\"info-circle-title\">Line Info Circle</title>\n        <path d=\"M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm0-338c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z\"></path>\n    </symbol>\n    <symbol id=\"link\" viewBox=\"0 0 512 512\">\n        <title id=\"link-title\">Link</title>\n        <path d=\"M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z\"></path>\n    </symbol>\n    <symbol id=\"pencil\" viewBox=\"0 0 512 512\">\n        <title id=\"pencil-title\">Pencil</title>\n        <path d=\"M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z\"></path>\n    </symbol>\n    <symbol id=\"plug\" viewBox=\"0 0 384 512\">\n        <title id=\"plug-title\">Plug</title>\n        <path d=\"M256 144V32c0-17.673 14.327-32 32-32s32 14.327 32 32v112h-64zm112 16H16c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h16v32c0 77.406 54.969 141.971 128 156.796V512h64v-99.204c73.031-14.825 128-79.39 128-156.796v-32h16c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16zm-240-16V32c0-17.673-14.327-32-32-32S64 14.327 64 32v112h64z\"></path>\n    </symbol>\n    <symbol id=\"plus\" viewBox=\"0 0 448 512\">\n        <title id=\"plus-title\">plus</title>\n        <path d=\"M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z\"></path>\n    </symbol>\n    <symbol id=\"search\" viewBox=\"0 0 512 512\">\n        <title id=\"search-title\">Search</title>\n        <path d=\"M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z\"></path>\n    </symbol>\n    <symbol id=\"shopping-cart\" viewBox=\"0 0 576 512\">\n        <title id=\"shopping-cart-title\">shopping-cart</title>\n        <path d=\"M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z\"></path>\n    </symbol>\n    <symbol id=\"sort-amount-down\" viewBox=\"0 0 512 512\">\n        <title id=\"sort-amount-down-title\">Sort Amount Down</title>\n        <path d=\"M187.298 395.314l-79.984 80.002c-6.248 6.247-16.383 6.245-22.627 0L4.705 395.314C-5.365 385.244 1.807 368 16.019 368H64V48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v320h47.984c14.241 0 21.363 17.264 11.314 27.314zM240 96h256c8.837 0 16-7.163 16-16V48c0-8.837-7.163-16-16-16H240c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16zm-16 112v-32c0-8.837 7.163-16 16-16h192c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H240c-8.837 0-16-7.163-16-16zm0 256v-32c0-8.837 7.163-16 16-16h64c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-64c-8.837 0-16-7.163-16-16zm0-128v-32c0-8.837 7.163-16 16-16h128c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H240c-8.837 0-16-7.163-16-16z\"></path>\n    </symbol>\n    <symbol id=\"sort-amount-up\" viewBox=\"0 0 512 512\">\n        <title id=\"sort-amount-up-title\">Sort Amount Up</title>\n        <path d=\"M4.702 116.686l79.984-80.002c6.248-6.247 16.383-6.245 22.627 0l79.981 80.002c10.07 10.07 2.899 27.314-11.314 27.314H128v320c0 8.837-7.163 16-16 16H80c-8.837 0-16-7.163-16-16V144H16.016c-14.241 0-21.363-17.264-11.314-27.314zM240 96h256c8.837 0 16-7.163 16-16V48c0-8.837-7.163-16-16-16H240c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16zm-16 112v-32c0-8.837 7.163-16 16-16h192c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H240c-8.837 0-16-7.163-16-16zm0 256v-32c0-8.837 7.163-16 16-16h64c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-64c-8.837 0-16-7.163-16-16zm0-128v-32c0-8.837 7.163-16 16-16h128c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H240c-8.837 0-16-7.163-16-16z\"></path>\n    </symbol>\n    <symbol id=\"th\" viewBox=\"0 0 512 512\">\n        <title id=\"th-title\">th</title>\n        <path d=\"M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z\"></path>\n    </symbol>\n    <symbol id=\"times\" viewBox=\"0 0 352 512\">\n        <title id=\"times-title\">Times</title>\n        <path d=\"M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z\"></path>\n    </symbol>\n    <symbol id=\"user\" viewBox=\"0 0 448 512\">\n        <title id=\"user-title\">User</title>\n        <path d=\"M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z\"></path>\n    </symbol>\n\n    <view id=\"angle-double-left-view\" viewBox=\"0 0 448 512\" />\n    <view id=\"angle-double-right-view\" viewBox=\"0 513 448 512\" />\n    <view id=\"angle-left-view\" viewBox=\"0 1026 256 512\" />\n    <view id=\"angle-right-view\" viewBox=\"0 1539 256 512\" />\n    <view id=\"bars-view\" viewBox=\"0 2052 448 512\" />\n    <view id=\"book-view\" viewBox=\"0 2565 448 512\" />\n    <view id=\"check-view\" viewBox=\"0 3078 512 512\" />\n    <view id=\"check-circle-view\" viewBox=\"0 3591 512 512\" />\n    <view id=\"copy-view\" viewBox=\"0 4104 448 512\" />\n    <view id=\"exclamation-circle-view\" viewBox=\"0 4617 512 512\" />\n    <view id=\"exclamation-triangle-view\" viewBox=\"0 5130 576 512\" />\n    <view id=\"glass-martini-view\" viewBox=\"0 5643 512 512\" />\n    <view id=\"handshake-view\" viewBox=\"0 6156 640 512\" />\n    <view id=\"heart-view\" viewBox=\"0 6669 640 512\" />\n    <view id=\"line-heart-view\" viewBox=\"0 7182 640 512\" />\n    <view id=\"image-view\" viewBox=\"0 7695 512 512\" />\n    <view id=\"info-circle-view\" viewBox=\"0 8208 512 512\" />\n    <view id=\"key-view\" viewBox=\"0 8721 512 512\" />\n    <view id=\"line-check-circle-view\" viewBox=\"0 9234 512 512\" />\n    <view id=\"line-exclamation-circle-view\" viewBox=\"0 9747 512 512\" />\n    <view id=\"line-exclamation-triangle-view\" viewBox=\"0 10260 512 512\" />\n    <view id=\"line-info-circle-view\" viewBox=\"0 10773 512 512\" />\n    <view id=\"link-view\" viewBox=\"0 11286 512 512\" />\n    <view id=\"pencil-view\" viewBox=\"0 11799 512 512\" />\n    <view id=\"plug-view\" viewBox=\"0 12312 384 512\" />\n    <view id=\"plus-view\" viewBox=\"0 12825 448 512\" />\n    <view id=\"search-view\" viewBox=\"0 13338 512 512\" />\n    <view id=\"shopping-cart-view\" viewBox=\"0 13851 576 512\" />\n    <view id=\"sort-amount-down-view\" viewBox=\"0 14364 512 512\" />\n    <view id=\"sort-amount-up-view\" viewBox=\"0 14877 512 512\" />\n    <view id=\"th-view\" viewBox=\"0 15390 512 512\" />\n    <view id=\"times-view\" viewBox=\"0 15903 352 512\" />\n    <view id=\"user-view\" viewBox=\"0 16416 448 512\" />\n    <view id=\"line-lightbulb-view\" viewBox=\"0 16929 352 512\" />\n    <view id=\"chevron-left-view\" viewBox=\"0 17442 256 512\" />\n    <view id=\"chevron-right-view\" viewBox=\"0 17995 256 512\" />\n\n    <use xlink:href=\"#angle-double-left\" id=\"angle-double-left\" x=\"0\" y=\"0\" width=\"448\" height=\"512\"></use>\n    <use xlink:href=\"#angle-double-right\" id=\"angle-double-right\" x=\"0\" y=\"513\" width=\"448\" height=\"512\"></use>\n    <use xlink:href=\"#angle-left\" id=\"angle-left\" x=\"0\" y=\"1026\" width=\"256\" height=\"512\"></use>\n    <use xlink:href=\"#angle-right\" id=\"angle-right\" x=\"0\" y=\"1539\" width=\"256\" height=\"512\"></use>\n    <use xlink:href=\"#bars\" id=\"bars\" x=\"0\" y=\"2052\" width=\"448\" height=\"512\"></use>\n    <use xlink:href=\"#book\" id=\"book\" x=\"0\" y=\"2565\" width=\"448\" height=\"512\"></use>\n    <use xlink:href=\"#check\" id=\"check\" x=\"0\" y=\"3078\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#check-circle\" id=\"check-circle\" x=\"0\" y=\"3591\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#copy\" id=\"copy\" x=\"0\" y=\"4104\" width=\"448\" height=\"512\"></use>\n    <use xlink:href=\"#exclamation-circle\" id=\"exclamation-circle\" x=\"0\" y=\"4617\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#exclamation-triangle\" id=\"exclamation-triangle\" x=\"0\" y=\"5130\" width=\"576\" height=\"512\"></use>\n    <use xlink:href=\"#glass-martini\" id=\"glass-martini\" x=\"0\" y=\"5643\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#handshake\" id=\"handshake\" x=\"0\" y=\"6156\" width=\"640\" height=\"512\"></use>\n    <use xlink:href=\"#heart\" id=\"heart\" x=\"0\" y=\"6669\" width=\"640\" height=\"512\"></use>\n    <use xlink:href=\"#line-heart\" id=\"line-heart\" x=\"0\" y=\"7182\" width=\"640\" height=\"512\"></use>\n    <use xlink:href=\"#image\" id=\"image\" x=\"0\" y=\"7695\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#info-circle\" id=\"info-circle\" x=\"0\" y=\"8208\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#key\" id=\"key\" x=\"0\" y=\"8721\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#line-check-circle\" id=\"line-check-circle\" x=\"0\" y=\"9234\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#line-exclamation-circle\" id=\"line-exclamation-circle\" x=\"0\" y=\"9747\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#line-exclamation-triangle\" id=\"line-exclamation-triangle\" x=\"0\" y=\"10260\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#line-info-circle\" id=\"line-info-circle\" x=\"0\" y=\"10773\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#link\" id=\"link\" x=\"0\" y=\"11286\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#pencil\" id=\"pencil\" x=\"0\" y=\"11799\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#plug\" id=\"plug\" x=\"0\" y=\"12312\" width=\"384\" height=\"512\"></use>\n    <use xlink:href=\"#plus\" id=\"plus\" x=\"0\" y=\"12825\" width=\"448\" height=\"512\"></use>\n    <use xlink:href=\"#search\" id=\"search\" x=\"0\" y=\"13338\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#shopping-cart\" id=\"shopping-cart\" x=\"0\" y=\"13851\" width=\"576\" height=\"512\"></use>\n    <use xlink:href=\"#sort-amount-down\" id=\"sort-amount-down\" x=\"0\" y=\"14364\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#sort-amount-up\" id=\"sort-amount-up\" x=\"0\" y=\"14877\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#th\" id=\"th\" x=\"0\" y=\"15390\" width=\"512\" height=\"512\"></use>\n    <use xlink:href=\"#times\" id=\"times\" x=\"0\" y=\"15903\" width=\"352\" height=\"512\"></use>\n    <use xlink:href=\"#user\" id=\"user\" x=\"0\" y=\"16416\" width=\"448\" height=\"512\"></use>\n    <use xlink:href=\"#line-lightbulb\" id=\"line-lightbulb\" x=\"0\" y=\"16929\" width=\"352\" height=\"512\"></use>\n    <use xlink:href=\"#chevron-left\" id=\"chevron-left\" x=\"0\" y=\"17442\" width=\"256\" height=\"512\"></use>\n    <use xlink:href=\"#chevron-right\" id=\"chevron-right\" x=\"0\" y=\"17995\" width=\"256\" height=\"512\"></use>\n</svg>\n";

var CraftIcons = {
  install: function install() {
    if (typeof document !== 'undefined') {
      var iconsWrapper = document.createElement('div');
      iconsWrapper.style.display = 'none';
      iconsWrapper.innerHTML = iconsSvg;
      document.body.insertBefore(iconsWrapper, document.body.firstChild);
    }
  }
};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'Btn',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    kind: {
      type: String,
      default: 'default'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    to: {
      type: String,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: null
    }
  },
  computed: {
    component: function component() {
      if (this.to !== null) {
        return 'router-link';
      }

      if (this.href !== null) {
        return 'a';
      }

      return 'button';
    },
    computedType: function computedType() {
      if (this.to !== null || this.href !== null) {
        return null;
      }

      return this.type;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"c-btn",class:[( _obj = {
            small: _vm.small,
            large: _vm.large,
            block: _vm.block,
            outline: _vm.outline,
            loading: _vm.loading
        }, _obj[_vm.kind] = true, _obj['c-btn-icon'] =  _vm.icon && !_vm.$slots.default, _obj )],attrs:{"to":_vm.to,"href":_vm.href,"target":_vm.target,"type":_vm.computedType,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?[_c('spinner')]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"c-btn-content"},[(_vm.icon && _vm.icon.length > 0)?_c('icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Btn = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array | Boolean,
      default: null
    },
    id: {
      type: String,
      default: function _default() {
        return 'c-checkbox-id-' + this._uid;
      }
    },
    label: {
      type: String,
      default: null
    },
    modelValue: {
      default: undefined
    },
    value: {
      type: String | Boolean,
      default: null
    }
  },
  computed: {
    state: function state() {
      if (this.modelValue === undefined) {
        return this.checked;
      }

      if (Array.isArray(this.modelValue)) {
        return this.modelValue.indexOf(this.value) > -1;
      }

      return !!this.modelValue;
    }
  },
  methods: {
    onChange: function onChange() {
      this.toggle();
    },
    toggle: function toggle() {
      var value;

      if (Array.isArray(this.modelValue)) {
        value = this.modelValue.slice(0);

        if (this.state) {
          value.splice(value.indexOf(this.value), 1);
        } else {
          value.push(this.value);
        }
      } else {
        value = !this.state;
      }

      this.$emit('input', value);
    }
  },
  watch: {
    checked: function checked(newValue) {
      if (newValue !== this.state) {
        this.toggle();
      }
    }
  },
  mounted: function mounted() {
    if (this.checked && !this.state) {
      this.toggle();
    }
  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field',{staticClass:"c-checkbox",attrs:{"id":_vm.id,"errors":_vm.errors}},[_c('label',[_c('input',{attrs:{"type":"checkbox","id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.state},on:{"change":_vm.onChange}}),_vm._v("\n\n        "+_vm._s(_vm.label)+"\n    ")])])};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Checkbox = normalizeComponent_1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  props: {
    errors: {
      type: Array | Boolean,
      default: null
    },
    id: {
      type: String,
      default: function _default() {
        return 'c-field-id-' + this._uid;
      }
    },
    instructions: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-field",attrs:{"id":'field-' + _vm.id}},[(_vm.label)?_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(_vm.instructions)?_c('div',{staticClass:"instructions"},[_c('p',[_vm._v(_vm._s(_vm.instructions))])]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._l((_vm.errors),function(error,key){return (_vm.errors)?[_c('div',{key:key,staticClass:"invalid-feedback"},[_vm._v(_vm._s(error))])]:_vm._e()})],2)};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Field = normalizeComponent_1(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

//
var script$3 = {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array | Boolean,
      default: null
    },
    fullwidth: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: function _default() {
        return 'c-dropdown-id-' + this._uid;
      }
    },
    instructions: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: null
    },
    value: {
      type: String | Number,
      default: null
    }
  },
  components: {
    Field: Field
  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field',{staticClass:"c-dropdown",attrs:{"id":_vm.id + '-label',"label":_vm.label,"instructions":_vm.instructions,"errors":_vm.errors}},[_c('div',{staticClass:"c-dropdown-input",class:{'is-invalid': (_vm.errors && _vm.errors.length > 0)}},[_c('div',{staticClass:"select"},[_c('select',{class:{ 'w-full': _vm.fullwidth },attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.value)}}},_vm._l((_vm.options),function(option,key){return _c('option',{key:key,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label))])}),0)])])])};
var __vue_staticRenderFns__$3 = [];

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Dropdown = normalizeComponent_1(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
var script$4 = {
  props: {
    icon: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'base'
    }
  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */
var __vue_render__$4 = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"c-icon",class:( _obj = {}, _obj['size-' + _vm.size] = true, _obj ),attrs:{"viewBox":"0 0 18 18","width":"18","height":"18","role":"presentation"}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":'#' + _vm.icon}})])};
var __vue_staticRenderFns__$4 = [];

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Icon = normalizeComponent_1(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    undefined,
    undefined
  );

//
var script$5 = {
  props: {
    checked: {
      type: Boolean,
      default: null
    },
    disabled: {
      type: Boolean,
      default: null
    },
    errors: {
      type: Array | Boolean,
      default: null
    },
    id: {
      type: String,
      default: function _default() {
        return 'c-lightswitch-id-' + this._uid;
      }
    },
    instructions: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  components: {
    Field: Field
  },
  methods: {
    onChange: function onChange($event) {
      this.$emit('update:checked', $event.target.checked);
      this.$emit('change', $event.target.checked);
    }
  }
};

/* script */
const __vue_script__$5 = script$5;
/* template */
var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field',{staticClass:"c-lightswitch",attrs:{"id":_vm.id,"label":_vm.label,"instructions":_vm.instructions,"errors":_vm.errors}},[_c('div',{staticClass:"c-lightswitch-input"},[_c('label',{staticClass:"lightswitch",class:{disabled: _vm.disabled},attrs:{"for":_vm.id}},[_c('input',{attrs:{"id":_vm.id,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"slider round"})])])])};
var __vue_staticRenderFns__$5 = [];

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Lightswitch = normalizeComponent_1(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$6 = {
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array | Boolean,
      default: null
    },
    id: {
      type: String,
      default: function _default() {
        return 'c-radio-id-' + this._uid;
      }
    },
    instructions: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    modelValue: {
      default: undefined
    },
    value: {
      default: ''
    }
  },
  computed: {
    state: function state() {
      if (this.modelValue === undefined) {
        return this.checked;
      }

      return this.modelValue === this.value;
    }
  },
  methods: {
    onChange: function onChange() {
      this.toggle();
    },
    toggle: function toggle() {
      this.$emit('input', this.state ? '' : this.value);
    }
  },
  watch: {
    checked: function checked(newValue) {
      if (newValue !== this.state) {
        this.toggle();
      }
    }
  },
  mounted: function mounted() {
    if (this.checked && !this.state) {
      this.toggle();
    }
  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */
var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field',{staticClass:"c-radio",attrs:{"id":_vm.id,"errors":_vm.errors}},[_c('label',[_c('input',{attrs:{"type":"radio","id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.state},on:{"change":_vm.onChange}}),_vm._v("\n\n        "+_vm._s(_vm.label)+"\n    ")])])};
var __vue_staticRenderFns__$6 = [];

  /* style */
  const __vue_inject_styles__$6 = undefined;
  /* scoped */
  const __vue_scope_id__$6 = undefined;
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Radio = normalizeComponent_1(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
var script$7 = {
  props: {
    size: {
      type: String,
      default: 'base'
    }
  }
};

/* script */
const __vue_script__$7 = script$7;
/* template */
var __vue_render__$7 = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-spinner",class:( _obj = {}, _obj[_vm.size] = true, _obj )},[_c('div',{staticClass:"animation"})])};
var __vue_staticRenderFns__$7 = [];

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = undefined;
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Spinner = normalizeComponent_1(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    undefined,
    undefined
  );

function maskit(value, mask) {
  var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var tokens = arguments.length > 3 ? arguments[3] : undefined;
  value = value || '';
  mask = mask || '';
  var iMask = 0;
  var iValue = 0;
  var output = '';

  while (iMask < mask.length && iValue < value.length) {
    var cMask = mask[iMask];
    var masker = tokens[cMask];
    var cValue = value[iValue];

    if (masker && !masker.escape) {
      if (masker.pattern.test(cValue)) {
        output += masker.transform ? masker.transform(cValue) : cValue;
        iMask++;
      }

      iValue++;
    } else {
      if (masker && masker.escape) {
        iMask++; // take the next mask char and treat it as char

        cMask = mask[iMask];
      }

      if (masked) output += cMask;
      if (cValue === cMask) iValue++; // user typed the same char

      iMask++;
    }
  } // fix mask that ends with a char: (#)


  var restOutput = '';

  while (iMask < mask.length && masked) {
    var cMask = mask[iMask];

    if (tokens[cMask]) {
      restOutput = '';
      break;
    }

    restOutput += cMask;
    iMask++;
  }

  return output + restOutput;
}

function dynamicMask(maskit, masks, tokens) {
  masks = masks.sort(function (a, b) {
    return a.length - b.length;
  });
  return function (value, mask) {
    var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var i = 0;

    while (i < masks.length) {
      var currentMask = masks[i];
      i++;
      var nextMask = masks[i];

      if (!(nextMask && maskit(value, nextMask, true, tokens).length > currentMask.length)) {
        return maskit(value, currentMask, masked, tokens);
      }
    }

    return ''; // empty masks
  };
}

function masker (value, mask) {
  var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var tokens = arguments.length > 3 ? arguments[3] : undefined;
  return Array.isArray(mask) ? dynamicMask(maskit, mask, tokens)(value, mask, masked, tokens) : maskit(value, mask, masked, tokens);
}

var tokens = {
  '#': {
    pattern: /\d/
  },
  'X': {
    pattern: /[0-9a-zA-Z]/
  },
  'S': {
    pattern: /[a-zA-Z]/
  },
  'A': {
    pattern: /[a-zA-Z]/,
    transform: function transform(v) {
      return v.toLocaleUpperCase();
    }
  },
  'a': {
    pattern: /[a-zA-Z]/,
    transform: function transform(v) {
      return v.toLocaleLowerCase();
    }
  },
  '!': {
    escape: true
  } // https://github.com/fernandofleury/vanilla-masker/blob/master/lib/vanilla-masker.js
  // DIGIT = "9",
  // ALPHA = "A",
  // ALPHANUM = "S"
  // https://github.com/niksmr/vue-masked-input
  // 1 - number
  // a - letter
  // A - letter, forced to upper case when entered
  // * - alphanumeric
  // # - alphanumeric, forced to upper case when entered
  // + - any character
  // https://github.com/probil/v-mask
  // #	Number (0-9)
  // A	Letter in any case (a-z,A-Z)
  // N	Number or letter
  // X	Any symbol
  // https://github.com/igorescobar/jQuery-Mask-Plugin/blob/master/src/jquery.mask.js#L518
  // '0': {pattern: /\d/},
  // '9': {pattern: /\d/, optional: true},
  // '#': {pattern: /\d/, recursive: true},
  // 'A': {pattern: /[a-zA-Z0-9]/},
  // 'S': {pattern: /[a-zA-Z]/}
  // https://github.com/the-darc/string-mask
  // 0	Any numbers
  // 9	Any numbers (Optional)
  // #	Any numbers (recursive)
  // A	Any alphanumeric character
  // a	Any alphanumeric character (Optional) Not implemented yet
  // S	Any letter
  // U	Any letter (All lower case character will be mapped to uppercase)
  // L	Any letter (All upper case character will be mapped to lowercase)
  // $	Escape character, used to escape any of the special formatting characters.

};

function event(name) {
  var evt = document.createEvent('Event');
  evt.initEvent(name, true, true);
  return evt;
}

function mask (el, binding) {
  var config = binding.value;

  if (Array.isArray(config) || typeof config === 'string') {
    config = {
      mask: config,
      tokens: tokens
    };
  }

  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input');

    if (els.length !== 1) {
      throw new Error("v-mask directive requires 1 input, found " + els.length);
    } else {
      el = els[0];
    }
  }

  el.oninput = function (evt) {
    if (!evt.isTrusted) return; // avoid infinite loop

    /* other properties to try to diferentiate InputEvent of Event (custom)
    InputEvent (native)
      cancelable: false
      isTrusted: true
       composed: true
      isComposing: false
      which: 0
     Event (custom)
      cancelable: true
      isTrusted: false
    */
    // by default, keep cursor at same position as before the mask

    var position = el.selectionEnd; // save the character just inserted

    var digit = el.value[position - 1];
    el.value = masker(el.value, config.mask, true, config.tokens); // if the digit was changed, increment position until find the digit again

    while (position < el.value.length && el.value.charAt(position - 1) !== digit) {
      position++;
    }

    if (el === document.activeElement) {
      el.setSelectionRange(position, position);
      setTimeout(function () {
        el.setSelectionRange(position, position);
      }, 0);
    }

    el.dispatchEvent(event('input'));
  };

  var newDisplay = masker(el.value, config.mask, true, config.tokens);

  if (newDisplay !== el.value) {
    el.value = newDisplay;
    el.dispatchEvent(event('input'));
  }
}

//
var script$8 = {
  directives: {
    mask: {
      bind: function bind(el, binding, vnode) {
        if (vnode.context.mask) {
          return mask(el, binding);
        }
      }
    }
  },
  watch: {
    value: function value(newVal) {
      if (this.$refs.input.value !== newVal) {
        this.$refs.input.value = newVal;
      }
    }
  },
  props: {
    autocapitalize: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'on'
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    cols: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array | Boolean,
      default: null
    },
    id: {
      type: String,
      default: function _default() {
        return 'c-textbox-id-' + this._uid;
      }
    },
    instructions: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    mask: {
      type: String | Object,
      default: ''
    },
    max: {
      type: Number | String,
      default: null
    },
    min: {
      type: Number | String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    pattern: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number | String,
      default: null
    },
    size: {
      type: Number | String,
      default: null
    },
    spellcheck: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number | String,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String | Number,
      default: ''
    }
  },
  components: {
    Field: Field
  },
  computed: {
    remainingChars: function remainingChars() {
      if (this.max) {
        return this.max - this.value.length;
      }
    },
    computedComponent: function computedComponent() {
      if (this.type === 'textarea') {
        return 'textarea';
      }

      return 'input';
    },
    computedType: function computedType() {
      if (this.type === 'textarea') {
        return null;
      }

      return this.type;
    },
    computedCols: function computedCols() {
      if (this.type !== 'textarea') {
        return null;
      }

      return this.cols;
    },
    computedRows: function computedRows() {
      if (this.type !== 'textarea') {
        return null;
      }

      return this.rows ? this.rows : 4;
    }
  },
  created: function created() {
    this.$on('focus', function () {
      this.$refs.input.focus();
    });
  }
};

/* script */
const __vue_script__$8 = script$8;
/* template */
var __vue_render__$8 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field',{staticClass:"c-textbox",attrs:{"id":_vm.id,"label":_vm.label,"instructions":_vm.instructions,"errors":_vm.errors}},[_c('div',{staticClass:"wrapper"},[_c(_vm.computedComponent,{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],ref:"input",tag:"component",class:{
                    'w-full': !_vm.size,
                    'is-invalid': _vm.errors && _vm.errors.length > 0,
                    'text-red-dark': _vm.max && _vm.max < this.value.length
                },attrs:{"autocapitalize":_vm.autocapitalize,"autocomplete":_vm.autocomplete,"autofocus":_vm.autofocus,"cols":_vm.computedCols,"disabled":_vm.disabled,"id":_vm.id,"mask":_vm.mask,"max":_vm.max,"min":_vm.min,"name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"rows":_vm.computedRows,"size":_vm.size,"spellcheck":_vm.spellcheck,"step":_vm.step,"type":_vm.computedType,"value":_vm.value},on:{"blur":function($event){return _vm.$emit('blur', $event)},"focus":function($event){return _vm.$emit('focus', $event.target.value)},"change":function($event){return _vm.$emit('change', $event)},"input":function($event){return _vm.$emit('input', $event.target.value)},"keydown":function($event){return _vm.$emit('keydown', $event)},"keypress":function($event){return _vm.$emit('keypress', $event)},"keyup":function($event){return _vm.$emit('keyup', $event)}}},[(_vm.type === 'textarea')?[_vm._v(_vm._s(_vm.value))]:_vm._e()],2),_vm._v(" "),(_vm.max)?_c('p',{staticClass:"max",class:{
                'text-grey': _vm.remainingChars >= 20,
                'text-orange': _vm.remainingChars < 20 && _vm.remainingChars >= 0,
                'text-red': _vm.remainingChars < 0
            }},[_c('small',[_vm._v(_vm._s((_vm.max - _vm.remainingChars))+"/"+_vm._s(_vm.max))])]):_vm._e()],1)])};
var __vue_staticRenderFns__$8 = [];

  /* style */
  const __vue_inject_styles__$8 = undefined;
  /* scoped */
  const __vue_scope_id__$8 = undefined;
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Textbox = normalizeComponent_1(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    undefined,
    undefined
  );

var CraftComponents = {
  Btn: Btn,
  Checkbox: Checkbox,
  Dropdown: Dropdown,
  Field: Field,
  Icon: Icon,
  Lightswitch: Lightswitch,
  Radio: Radio,
  Spinner: Spinner,
  Textbox: Textbox
};

var index = {
  install: function install(Vue) {
    Vue.use(CraftIcons); // Craft Components

    Object.keys(CraftComponents).forEach(function (name) {
      Vue.component(name, CraftComponents[name]);
    });
  }
};

export default index;
